import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const ErrorSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.9957 22.0044C17.4667 22.0044 22 17.4778 22 12.0044C22 6.53098 17.458 2.00439 11.9869 2.00439C6.5207 2.00439 2 6.53098 2 12.0044C2 17.4778 6.52941 22.0044 11.9957 22.0044ZM11.9957 13.8376C11.5443 13.8376 11.2875 13.5641 11.2788 13.0969L11.1547 7.70719C11.146 7.22732 11.4938 6.88811 11.9869 6.88811C12.4801 6.88811 12.8366 7.23604 12.8279 7.7159L12.7038 13.0969C12.6951 13.5728 12.4383 13.8376 11.9957 13.8376ZM11.9957 17.0553C11.4508 17.0553 10.9768 16.6129 10.9768 16.0708C10.9768 15.5209 11.4421 15.0777 11.9957 15.0777C12.554 15.0777 13.0232 15.5122 13.0232 16.0708C13.0232 16.6216 12.5453 17.0553 11.9957 17.0553Z"
        fill={color}
      />
    </svg>
  );
};

export { ErrorSvg };
